/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable camelcase */
// 9fbef606107a605d69c0edbcd8029e5d
import withResize from '@tcp/core/src/components/common/hoc/withResize';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import React, { useRef, useMemo } from 'react';
import { routerPush, setSessionStorage } from '@tcp/core/src/utils';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '@tcp/core/src/utils/labels/labelUtilty';
import { setLocalStorage } from '@tcp/core/src/utils/localStorageManagement';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor/views/Anchor';
import { globalDepartmentLabels } from '@tcp/core/src/utils/labels/globalDepartment.labels';
import { PLPLabels } from '@tcp/core/src/utils/labels/browse/PLP.labels';
import { SLASH_C_ROUTE, SLASH_C_PATH } from '../../../../../constants/plp.constants';
import HlpTileView from '../../PlpTile/views/HlpTile.view';
import HorizontalCarousel from '../molecules/HorizontalCarousel/HorizontalCarousel';
import {
  CategoryBar,
  HrCarouselDesktop,
  SeoHeaderData,
  ContainerDiv,
  SeoText,
  StyledESpotPromoSkeleton,
} from '../styles/HorizontalCaouselDesktop.style';
import {
  ARROW_VISIBLE_BP,
  calculateBreakPointByWidth,
  SLIDES_TO_SCROLL_BP,
} from './carouselConfig';
import ShopAllTile from './ShopAllTile';
import { isShopThisStoreModeOn } from '../../../../../reduxStore/selectors/session.selectors';
import hlpLocators from './hlpLocators';
import { SHOP_THIS_STORE_SCROLL } from '../../../../../constants/shopThisStore.constant';

const ModuleDynamic = dynamic(
  () =>
    import(
      // eslint-disable-next-line extra-rules/no-commented-out-code
      /* webpackChunkName: "moduleDynamic" */ '@tcp/core/src/components/common/molecules/ModuleDynamic'
    ),
  {
    ssr: false,
    loading: () => {
      return <StyledESpotPromoSkeleton />;
    },
  }
);

const constructPaths = (categoryInfo, router) => {
  const { seoToken, url } = categoryInfo;
  const { asPath: asPathFromRouter } = router;
  const params = asPathFromRouter.includes('?') ? asPathFromRouter.split('?') : '';
  const query = params ? params[params.length - 1] : '';
  const redirectSeoToken = url?.replace('#redirect', '')?.replace('/c?cid=', '') || seoToken;
  const asPath = `${SLASH_C_ROUTE}${redirectSeoToken}${query ? '?' : ''}${query}`;
  let href = `${SLASH_C_PATH}cid=${redirectSeoToken}${query ? '?' : ''}${query}`;
  if (isShopThisStoreModeOn()) {
    setSessionStorage({ key: SHOP_THIS_STORE_SCROLL, value: window.scrollY });
    href = `${SLASH_C_PATH}cid=${url?.split('?')[0]}`;
  }
  return { asPath, href };
};

const HorizontalCarouselDesktop = (props) => {
  const viewAllLabel = getLabelFromCopyOrFromTranslation(
    'global.department.lbl_view_all',
    globalDepartmentLabels
  );

  const plpTileLabels = getLabelFromCopyOrFromTranslation('PLP.plpTiles', PLPLabels);

  const shopAllLabel = renderLabel(plpTileLabels.lbl_shop_all, 'lbl_shop_all');
  const itemsLabel = renderLabel(plpTileLabels.lbl_items, 'lbl_items');

  const {
    windowSize,
    onQuickViewOpenClick,
    onAddItemToFavorites,
    onSetLastDeletedItemIdAction,
    wishListData,
    submitButtonText,
    isShortImage,
    categoryInfo,
    products,
    numberOfProducts,
    pathName,
    saveProductDataForPdp,
    saveProductDataForQV,
    trackWishListClick,
    isTopRatedBackAbEnabled,
    isBestSellerBackAbEnabled,
    trackHorizontalPlpAnalytic,
    isSyteEnabled,
    isNewSwatchUrlEnabled,
    horizontalBlockIndex,
    addToBagIconInPLP,
    horizontalPlpProductsSeoData,
    addToBagEcom,
    isOneClickATCEnabled,
    isHideOriginalPriceAndMarchantTagEnabled,
    isInfluencerBadgeEnabled,
    isTileRedesignAB,
    router,
    promotionsData,
  } = props;
  const plpTileRef = useRef(null);

  const { id, name: categoryName } = categoryInfo;
  const categoryData = `${id}|${categoryName}`;
  const breakPoint = calculateBreakPointByWidth(windowSize);
  const seoHeaderData = horizontalPlpProductsSeoData[id];

  const { asPath: asPathNew, href: hrefnew } = useMemo(
    () => constructPaths(categoryInfo, router),
    [categoryInfo, router]
  );

  const handleLinkClick = (e) => {
    e.preventDefault();
    setLocalStorage({ key: 'prevCatId', value: id });
    const { asPath, href } = constructPaths(categoryInfo, router);
    routerPush(href, asPath);
  };
  return (
    <HrCarouselDesktop>
      <>
        <ContainerDiv>
          <CategoryBar>
            <div className="cat-info" data-locator={hlpLocators.catInfo}>
              <h3>{categoryName}</h3>
              <div className="item-count">
                ({numberOfProducts}) {itemsLabel}
              </div>
            </div>
            <div
              className="cat-link"
              data-locator={hlpLocators.viewAll}
              onClick={(e) => handleLinkClick(e)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleLinkClick(e);
                }
              }}
              role="button"
              tabIndex="0"
            >
              <Anchor
                title={viewAllLabel}
                onClick={(e) => e.preventDefault()}
                asPath={asPathNew}
                to={hrefnew}
              >
                {viewAllLabel}
              </Anchor>
            </div>
          </CategoryBar>
          <SeoHeaderData>
            <SeoText> {seoHeaderData} </SeoText>
          </SeoHeaderData>
        </ContainerDiv>
        <div className="carousel-wrapper">
          <HorizontalCarousel
            isArrowVisible={products.length > ARROW_VISIBLE_BP[breakPoint]}
            plpTileRef={plpTileRef}
            defaultTileWidth={265}
            slidesToScroll={SLIDES_TO_SCROLL_BP[breakPoint]}
            shouldDisplayCategoryNameOverlayOnInteraction={products.some(
              (a) => a.isESpotPlpContent
            )}
            categoryName={categoryName}
          >
            {products.map((productInfo, i) => {
              const preloadImage = horizontalBlockIndex === 0 && i < 2;

              if (productInfo?.isESpotPlpContent) {
                const { eSpotCatGrpId, provider, linkedImage } = productInfo || {};
                return (
                  <div
                    key={`plp-tile-${i}-${eSpotCatGrpId}`}
                    ref={i === 0 ? plpTileRef : null}
                    className="tile-wrapper espot-container"
                  >
                    <div className="hr-plp-tile espot-wrapper">
                      <ModuleDynamic
                        provider={provider}
                        linkedImage={linkedImage}
                        uniqueId={eSpotCatGrpId}
                        eSpotPromoKey={`${eSpotCatGrpId}-${i}`}
                      />
                    </div>
                  </div>
                );
              }
              return (
                <div
                  key={`plp-tile-${i}-${productInfo?.productid}`}
                  ref={i === 0 ? plpTileRef : null}
                  className="tile-wrapper"
                >
                  <HlpTileView
                    customClass="hr-plp-tile"
                    tileData={{ ...productInfo, categoryData }}
                    tileActions={{
                      onQuickViewOpenClick,
                      onAddItemToFavorites,
                      onSetLastDeletedItemIdAction,
                      addToBagEcom,
                    }}
                    wishListData={wishListData}
                    submitButtonText={submitButtonText}
                    isBrierleyPromoEnabled
                    isShortImage={isShortImage}
                    imageWidth={200}
                    pathName={pathName}
                    saveProductDataForPdp={saveProductDataForPdp}
                    saveProductDataForQV={saveProductDataForQV}
                    trackWishListClick={trackWishListClick}
                    isFromHPLP
                    isTopRatedBackAbEnabled={isTopRatedBackAbEnabled}
                    isBestSellerBackAbEnabled={isBestSellerBackAbEnabled}
                    isSyteEnabled={isSyteEnabled}
                    addToBagIconInPLP={addToBagIconInPLP}
                    trackAnalyticsClick={trackHorizontalPlpAnalytic}
                    isNewSwatchUrlEnabled={isNewSwatchUrlEnabled}
                    preloadImage={preloadImage}
                    isOneClickATCEnabled={isOneClickATCEnabled}
                    isHideOriginalPriceAndMarchantTagEnabled={
                      isHideOriginalPriceAndMarchantTagEnabled
                    }
                    isInfluencerBadgeEnabled={isInfluencerBadgeEnabled}
                    isTileRedesignAB={isTileRedesignAB}
                    promotionsData={promotionsData}
                  />
                </div>
              );
            })}
            <ShopAllTile
              shopAllLabel={shopAllLabel}
              numberOfProducts={numberOfProducts}
              itemsLabel={itemsLabel}
              categoryInfo={categoryInfo}
              device="desktop"
            />
          </HorizontalCarousel>
        </div>
      </>
    </HrCarouselDesktop>
  );
};
HorizontalCarouselDesktop.propTypes = {
  categoryInfo: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
    seoToken: PropTypes.string,
  }).isRequired,
  onQuickViewOpenClick: PropTypes.func,
  onAddItemToFavorites: PropTypes.func,
  onSetLastDeletedItemIdAction: PropTypes.func,
  saveProductDataForPdp: PropTypes.func,
  saveProductDataForQV: PropTypes.func,
  wishListData: PropTypes.arrayOf(PropTypes.shape({})),
  products: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  submitButtonText: PropTypes.string,
  pathName: PropTypes.string,
  isShortImage: PropTypes.bool,
  numberOfProducts: PropTypes.number.isRequired,
  windowSize: PropTypes.arrayOf(PropTypes.number),
  isTopRatedBackAbEnabled: PropTypes.bool,
  isBestSellerBackAbEnabled: PropTypes.bool,
  isNewSwatchUrlEnabled: PropTypes.bool,
  isOneClickATCEnabled: PropTypes.bool,
  addToBagEcom: PropTypes.func,
};
HorizontalCarouselDesktop.defaultProps = {
  onQuickViewOpenClick: () => {},
  onAddItemToFavorites: () => {},
  onSetLastDeletedItemIdAction: () => {},
  saveProductDataForPdp: () => {},
  saveProductDataForQV: () => {},
  wishListData: [],
  submitButtonText: '',
  pathName: '',
  isShortImage: false,
  windowSize: [],
  isTopRatedBackAbEnabled: false,
  isBestSellerBackAbEnabled: false,
  isNewSwatchUrlEnabled: false,
  isOneClickATCEnabled: false,
  addToBagEcom: () => {},
};
export { HorizontalCarouselDesktop as HorizontalCarouselDesktopVanilla };
export default withResize(HorizontalCarouselDesktop);
